import PortfolioVerticalSliderContainer from "../../../../components/pages/portfolio/portfolioPage/PortfolioVerticalSlider";

const PortfolioVerticalSlider = () => {
  return <PortfolioVerticalSliderContainer />;
};

export default PortfolioVerticalSlider;
